import { type ReactElement } from 'react';
import { PageHeader, Grid } from '@vello/web-theme';
import { CountCard } from '../components/count-card';
import { StatusPanel, useRealmCounts } from '../components/status-panel';
import { useT } from '../i18n/provider';

/**
 * Clientes › Painel (DevMobility C-031, recovering the D471 descope; V-OPS-CHARTS, D513): the customers' base counts from the
 * directory the Passageiros and Empresas screens already read — passengers and companies by status (`total` with `limit=1`,
 * scoped by the server, never a list). A read that fails or is refused reads "unavailable" with a retry, never a zero.
 */
export function CustomersDashboardScreen(): ReactElement {
  const { t } = useT();
  const riders = useRealmCounts('RIDER');
  const companies = useRealmCounts('BUSINESS');
  return (
    <>
      <PageHeader title={t('cdash.title')} subtitle={t('cdash.subtitle')} />

      <Grid min="xs" gap={4}>
        <CountCard label={t('cdash.riders.total')} state={riders.state} pick={(v: { total: number }) => v.total} />
        <CountCard label={t('dir.filter.active')} state={riders.state} pick={(v: { active: number }) => v.active} />
        <CountCard label={t('dir.filter.suspended')} state={riders.state} pick={(v: { suspended: number }) => v.suspended} />
        <CountCard label={t('cdash.companies.total')} state={companies.state} pick={(v: { total: number }) => v.total} />
      </Grid>

      <Grid min="lg" gap={4}>
        <StatusPanel title={t('cdash.riders.title')} totalLabel={t('cdash.riders.total')} state={riders.state} reload={riders.reload} />
        <StatusPanel title={t('cdash.companies.title')} totalLabel={t('cdash.companies.total')} state={companies.state} reload={companies.reload} />
      </Grid>
    </>
  );
}
